import * as Sentry from "@sentry/react";
import { ReactNode } from "react";
import { Button } from "./ui/button";

interface ErrorFallbackProps {
  error: Error;
  resetError: () => void;
}

const ErrorFallback = ({ error, resetError }: ErrorFallbackProps) => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-background p-8">
    <div className="text-center">
      <h2 className="mb-4 text-2xl font-bold text-destructive">
        Oops! Something went wrong
      </h2>
      <p className="mb-6 text-muted-foreground">
        We're sorry for the inconvenience. The error has been logged and we'll look into it.
      </p>
      <pre className="mb-6 max-w-md overflow-auto rounded bg-muted p-4 text-sm">
        {error.message}
      </pre>
      <div className="space-x-4">
        <Button onClick={resetError}>Try again</Button>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </div>
    </div>
  </div>
);

interface SentryErrorBoundaryProps {
  children: ReactNode;
}

export const SentryErrorBoundary = ({ children }: SentryErrorBoundaryProps) => {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  );
};